import { ApiError } from './api.error';

export class RequiredError extends ApiError {
    constructor(clazz: string, message: string, error?: Error) {
        super(clazz, message, error);
        Object.setPrototypeOf(this, RequiredError.prototype);
    }
}